import Quill from "quill";
import * as QuillJs from "quill";

import * as React from "react";
import ReactQuill from "react-quill";

import './quill.editor.css';
import "react-quill/dist/quill.snow.css";

//import "react-quill/dist/quill.bubble.css";
//import "react-quill/dist/quill.core.css";

import { AsyncUploadModel } from "models/ApiModels";
import RestUtilities from "lib/RestUtilities";

import "components/Quill/Mention";
import "components/Quill/MagicUrl";
import "components/Quill/ImageResize";
import "components/Quill/ClipboardExt";
import "components/Quill/ImageDropAndPaste";
import "components/Quill/Blots/ImageUrlBlot";
import "components/Quill/Blots/PublicationBlot";

//import "components/Quill/Blots/VideoBlot";
//import "components/Quill/Blots/VideoUrlBlot";
//import "components/Quill/Blots/YoutubeBlot";
//import { QuillVideoWatch } from 'components/Quill/VideoExtend';

import { quillMentionConfig } from "components/Quill/Mention/quillMentionConfig";
import PublicationSelectionDrawer from "views/Publication/Dialogs/PublicationSelectionDrawer";
import { getPublicationUrl } from "views/Timeline/Components/FeedHelpers";
import QuillContainer from "components/Quill/QuillContainer";
import { QuillUtils } from "components/Quill/QuillUtils";
import { PublicationType } from "models/ApiEnums";
import { ImageSelectionDialog } from "components/ImageHandler";
import { AsyncUploader } from "lib/AsyncUploader";
import { WithTranslation, withTranslation } from "react-i18next";
import { QuillTranslateToolbar } from "components/Quill/QuillTranslateToolbar";
import { EditorPicture, WidePicture } from "assets/appConfig";


export interface UnprivilegedEditor {
    getLength(): number;
    getText(index?: number, length?: number): string;
    getHTML(): string;
    getBounds(index: number, length?: number): QuillJs.BoundsStatic;
    getSelection(focus?: boolean): QuillJs.RangeStatic;
    getContents(index?: number, length?: number): QuillJs.DeltaStatic;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    dialog: any;
}

interface IProps {
    id?: string;
    content: string;
    onChange: (content: string, delta: QuillJs.Delta, source: QuillJs.Sources, editor: UnprivilegedEditor) => void;
    onFocus?: () => void;
    onRef?: (ref: HTMLElement) => void;

    autoFocus?: boolean;
    readOnly?: boolean;
    showToolbar?: boolean;
    className?: string;
    minHeight?: number | string;
    maxHeight?: number | string;
    placeholder?: string;
    theme?: "snow" | "bubble";
}

type Props = IProps & WithTranslation;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class QuillEditor extends React.PureComponent<Props, IState> {
    quill: any;
    id: string;
    /*
     * Quill editor formats
     * See https://quilljs.com/docs/formats/
     */
    EditorFormats: string[] = [
        'header', 'font', 'size', 'align', 'color', 'background',
        'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
        'list', 'bullet', 'indent', 'sub', 'super', 'direction',
        'link', 'clean',
        'mention', 'image', 'publication'
        //'youtube', 'videoUrl'
    ];

    /*
     * Quill modules to attach to editor
     * See https://quilljs.com/docs/modules/ for complete options
     */
    EditorModules: object = {
        toolbar: {
            container: [
                //[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': '1' }, { 'header': '2' }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['blockquote', 'code-block'],
                ['link', 'image', 'publication'],          // add's image support
                ['clean']
            ],

            handlers: {
                /****************************************************
                video: function () {
                    // ATENÇÃO: este 'this.quill.id' refere-se ao contexto de 'VideoExtend' e não ao editor atual.
                    QuillVideoWatch.emit(this.quill.id);
                },
                ****************************************************/

                image: () => this.imageSelectionHandler(),

                publication: () => this.publicationHandler()
            }
        },

        imageDropAndPaste: {
        },

        imageResize: {
        },

        magicUrl: {

        },

        clipboardExt: {
            image: true,
            video: false,
            youtube: false,

        },

        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: true,
        },

        /****************************************************************

        VideoExtend: {
            loading: true,
            name: 'video',
            action: "/api/v1.0/AsyncUpload/Save",
            headers: (xhr: any) => {
                // Permite ajustar o token (optional)
                //xhr.setRequestHeader('token', this.token);
            },
            response: (res: any) => {
                // retorna os dados para construção da TAG <video/>
                return {
                    src: res.mainFile.attachUrl,
                    width: res.mainFile.metadata.width,
                    height: res.mainFile.metadata.height,
                    title: res.mainFile.metadata.title || res.mainFile.metadata.description || res.mainFile.metadata.filename,
                };
            }
        },
        /****************************************************************/

        ...quillMentionConfig
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    constructor(props: Props) {
        super(props);
        this.state = { dialog: null };
        this.id = props.id || `ed_${new Date().getTime()}`;
    }

    static defaultProps = {
        showToolbar: true,
        autoFocus: false,
        readOnly: false
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    handleChange = (content: string,
        delta: QuillJs.Delta,
        source: QuillJs.Sources,
        editor: UnprivilegedEditor) => {

        this.props.onChange(content, delta, source, editor);
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /***********************************************************************
    videoHandler() {
        var fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', "video/mp4");
        fileInput.addEventListener('change', () => {
            const files = fileInput.files;

            if (!files || !files.length) {
                console.log('No files selected');
                return;
            }

            const range = this.quill.getSelection(true);

            this.quill.enable(false);

            const formData = new FormData();
            formData.append('file', files[0]);

            RestUtilities.post<AsyncUploadModel>('/api/v1.0/AsyncUpload/Save', formData)
                .then((response) => {
                    this.quill.enable(true);
                    this.quill.editor.insertEmbed(range.index, "video", response.mainFile.attachUrl);
                    this.quill.setSelection(range.index + 1, 1, "silient");
                    fileInput.value = '';
                })
                .catch((error) => {
                    console.log('quill image upload failed');
                    console.warn(error);
                    this.quill.enable(true);
                });
        });
        fileInput.click();
    }
     ************************************************************************/

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    imageHandler() {
        const utils = new QuillUtils();

        var fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', "image/png, image/gif, image/jpeg");
        fileInput.addEventListener('change', () => {
            const files = fileInput.files;

            if (!files || !files.length) {
                console.log('No files selected');
                return;
            }

            const range = this.quill.getSelection(true);

            const formData = new FormData();
            formData.append('file', files[0]);

            var cover = utils.createBackDrop();
            var container = document.querySelector(".ql-container");
            container.appendChild(cover);

            RestUtilities.post<AsyncUploadModel>('/api/v1.0/AsyncUpload/Save', formData)
                .then((response) => {
                    container.removeChild(cover);
                    this.quill.editor.insertEmbed(range.index, "image", response.mainFile.attachUrl);
                    this.quill.setSelection(range.index + 2, 1, "silient");
                    fileInput.value = '';
                })
                .catch((error) => {
                    console.log('quill image upload failed');
                    console.warn(error);
                    container.removeChild(cover);
                });
        });
        fileInput.click();
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    publicationHandler() {
        const q = this.quill.getEditor() as Quill;
        const range = q.getSelection();
        if (range == null) return;

        const cursorPos = range.index;
        this.setState({
            dialog: <PublicationSelectionDrawer
                title="Adicionar Link para Publicação"
                excludeOptions={
                    {
                        excludePublicationsType: [
                            PublicationType.Poll,
                            PublicationType.Survey,
                            PublicationType.Course
                        ]
                    }
                }
                onSelect={
                    (result) => {


                        q.focus();
                        setTimeout(() => {
                            if (result) {
                                const data = {
                                    url: getPublicationUrl(result.publication.publicationId, result.publication.publicationType),
                                    title: result.publication.title
                                };
                                q.insertEmbed(cursorPos, 'publication', data, "api");
                                q.insertText(cursorPos + 1, ' ', "api");
                                q.setSelection(cursorPos + 2, 1, "api");
                            }
                        }, 500);

                        return false;
                    }
                }

                onClose={
                    () => this.setState({ dialog: null })
                }
            />
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    imageSelectionHandler() {

        const q = this.quill.getEditor() as Quill;
        const range = q.getSelection(true);
        if (range == null) return;

        this.setState({
            dialog: (
                <ImageSelectionDialog
                    acceptedFiles={["image/*"]}
                    initialSource="library"
                    allowEdit={false}
                    dimensions={EditorPicture}
                    onClose={
                        (image) => {
                            if (image == null) {
                                this.setState({ dialog: null });
                            }
                            else {
                                const asyncUploader: AsyncUploader = new AsyncUploader(
                                    {
                                        onFileUploadError: () => {
                                            this.setState({ dialog: null, });
                                        },

                                        onFileUploadSuccess: (data: AsyncUploadModel) => {
                                            q.insertEmbed(range.index, "image", data.mainFile.tempUrl);
                                            q.setSelection(range.index + 2, 1, "silent");
                                            this.setState({ dialog: null });
                                        }
                                    });

                                asyncUploader.uploadImage(image.source);
                            }
                        }
                    }
                />
            )
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ///
    public componentDidMount() {
        var qtt = new QuillTranslateToolbar(this.id, this.props.t);
        qtt.translate();
    }

    ///
    public componentWillUnmount() {
        // Remove mention SE estiver aberto.
        var mentionContainer = document.getElementsByClassName("ql-mention-list-container");
        if (mentionContainer.length == 1) {
            mentionContainer[0].remove();
        }
    }

    ///
    public render() {
        const style = {
            minHeight: this.props.minHeight || "auto",
            maxHeight: this.props.maxHeight || "auto",
        };
        if (this.props.maxHeight) style["overflowY"] = "auto";

        return (
            <>
                <QuillContainer spellCheck={false} style={style} showToolbar={this.props.showToolbar ?? true} >
                    <ReactQuill
                        id={this.id}
                        ref={
                            (ref: any) => {
                                this.quill = ref;
                                if (ref != null && this.props.autoFocus) ref.focus();
                                if (this.props.onRef) this.props.onRef(ref as HTMLElement);
                            }
                        }
                        className={this.props.className}
                        theme={this.props.theme}
                        onChange={this.handleChange}
                        onFocus={this.props.onFocus}
                        readOnly={this.props.readOnly}
                        value={this.props.content}
                        modules={this.EditorModules}
                        formats={this.EditorFormats}
                        bounds={".quill-region"}
                        placeholder={this.props.placeholder}
                    />
                </QuillContainer>
                {this.state.dialog}
            </>
        );
    }
}

export default withTranslation()(QuillEditor);